export default __webpack_public_path__ + "static/media/main_7.b5997ab9.jpeg";